import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ScaButtonComponent } from '@argo-dev-components-sca-angular/dev-components-sca';

@Component({
  selector: 'app-access-denied',
  imports: [ScaButtonComponent],
  template: `
    <div class="access-denied-container">
      <div class="access-denied-content">
        <div class="error-icon">
          <svg width="120" height="120" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#e53e3e" stroke-width="2" fill="none"/>
            <path d="M15 9L9 15M9 9L15 15" stroke="#e53e3e" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
        
        <h1 class="error-title">Acceso Denegado</h1>
        <p class="error-description">
          No tienes los permisos necesarios para acceder a esta página.
        </p>
        
        <div class="error-details">
          <p><strong>Posibles razones:</strong></p>
          <ul>
            <li>No has iniciado sesión</li>
            <li>Tu sesión ha expirado</li>
            <li>No tienes los roles requeridos</li>
            <li>Tu cuenta no tiene acceso a este recurso</li>
          </ul>
        </div>
        
        <div class="action-buttons">
          <button 
            sca-button
            variant="primary"
            (click)="goHome()">
            Volver al inicio
          </button>
          
          <button 
            sca-button
            variant="border"
            (click)="goToLogin()">
            Iniciar sesión
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .access-denied-container {
      display: flex;
      justify-content: center;
      align-items: center;
   }
    
    .access-denied-content {
      background: white;
      border-radius: 16px;
      padding: 3rem;
      max-width: 600px;
      width: 100%;
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
      text-align: center;
    }
    
    .error-icon {
      margin-bottom: 2rem;
      animation: shake 0.5s;
    }
    
    @keyframes shake {
      0%, 100% { transform: translateX(0); }
      25% { transform: translateX(-10px); }
      75% { transform: translateX(10px); }
    }
    
    .error-title {
      font-size: 2.5rem;
      font-weight: bold;
      color: #2d3748;
      margin-bottom: 1rem;
    }
    
    .error-description {
      font-size: 1.125rem;
      color: #4a5568;
      margin-bottom: 2rem;
    }
    
    .error-details {
      background: #f7fafc;
      border-left: 4px solid #e53e3e;
      padding: 1.5rem;
      margin-bottom: 2rem;
      text-align: left;
      border-radius: 8px;
    }
    
    .error-details p {
      margin-bottom: 0.75rem;
      color: #2d3748;
      font-weight: 600;
    }
    
    .error-details ul {
      margin: 0;
      padding-left: 1.5rem;
      color: #4a5568;
    }
    
    .error-details li {
      margin-bottom: 0.5rem;
    }
    
    .action-buttons {
      display: flex;
      gap: 1rem;
      justify-content: center;
      flex-wrap: wrap;
    }
    
    .action-buttons button {
      min-width: 150px;
    }
  `]
})
export class AccessDeniedComponent {
  constructor(private router: Router) {}
  
  goHome(): void {
    this.router.navigate(['/home']);
  }
  
  goToLogin(): void {
    this.router.navigate(['/test/auth']);
  }
}
